import CONF from 'config/conf.singleton';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import asObject from 'utils/objects/asObject.util';

const authenticatedEndpoint = (options) => {
  const { root, pinSafe } = asObject(options);

  return Object.freeze({
    authenticated: true,
    api_root: fromAnyToString(root) || CONF.apiRoot,
    pinSafe: fromAnyToBool(pinSafe),
  });
};

// noinspection JSUnusedGlobalSymbols
export default authenticatedEndpoint;
